import React, { useContext, useEffect } from 'react';
import { Box, Flex, VStack } from '@chakra-ui/react';
import Container from '../../Layout/Container';
import { ParagraphSearchResults } from '../../../generated/types';
import SortField from '../../Common/SortField';
import SearchContext from '../../../context/SearchContext';
import renderTeaser from '../../../utils/render-teaser';
import { getNumberOfPages } from '../../../utils/pagination';
import Pagination from '../../Common/Pagination';
import { useRouter } from 'next/router';
import { applyMapParamToRoute, getSearchPath } from '../../../utils/helper';
import { USER_SELECTED_LOCATION_ON_MAP_TEXT } from '../../../config/constants';
import dynamic from 'next/dynamic';
import { useStore } from '../../../store/provider';

const SearchMap = dynamic(
  () => import('../../../components/Common/SearchMap'),
  {
    ssr: false,
  }
);

export interface SearchResultsProps {
  data: ParagraphSearchResults;
}

const PER_PAGE = 8;

const SearchResults: React.FC<SearchResultsProps> = ({ data }) => {
  const context = useContext(SearchContext);
  const router = useRouter();
  const store = useStore();

  useEffect(() => {
    store.search.setActiveFilters(
      data.result.activeFilters?.filter(
        (filter) => filter?.field !== 'category'
      )
    );
  }, [data]);

  const hasData = data && data.result.total > 0;

  const numberOfPages =
    hasData && getNumberOfPages(data.result!.total, PER_PAGE);
  const hasPagination =
    hasData && numberOfPages && data.result!.total > PER_PAGE;
  const currentPage = parseInt(router.query.page as string, 10) || 1;
  const isMap =
    router.query && (router.query.karte === '' || router.query.karte === '1');

  const onChangeCenter = (center: any) => {
    const searchPath = getSearchPath(
      context.activeCategory,
      USER_SELECTED_LOCATION_ON_MAP_TEXT,
      [center.lng.toFixed(6), center.lat.toFixed(6)],
      (context.form.radius || 30) + ''
    );

    router.push(applyMapParamToRoute(searchPath, isMap));
  };

  return (
    <Box marginY={12} className="ParagraphSearchResults">
      <Container>
        <Flex
          borderBottom="1px"
          borderBottomColor="textColor"
          paddingBottom={2}
          justifyContent="space-between"
          alignItems="center"
          flexDirection={{
            base: 'column',
            md: 'row',
          }}
        >
          <Box fontSize="lg" fontWeight="bold">
            {data.result.total} Ergebnisse
          </Box>
          <SortField category={context.activeCategory} />
        </Flex>
        {!isMap ? (
          <Box>
            <VStack marginTop={8} spacing={8}>
              {data.result.items.map((item) => renderTeaser(item))}
            </VStack>
            <Box>
              {hasPagination && (
                <Pagination total={data.result!.total} perPage={PER_PAGE} />
              )}
            </Box>
          </Box>
        ) : (
          <Box height="100vh">
            <SearchMap
              location={context.form.location}
              data={data!.result}
              radius={parseInt(context.form.radius, 10) || 30}
              onChangeCenter={onChangeCenter}
            />
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default SearchResults;
